exports.components = {
  "component---src-pages-es-us-tsx": () => import("./../../../src/pages/es-us.tsx" /* webpackChunkName: "component---src-pages-es-us-tsx" */),
  "component---src-pages-typeform-tsx": () => import("./../../../src/pages/typeform.tsx" /* webpackChunkName: "component---src-pages-typeform-tsx" */),
  "component---src-pages-us-tsx": () => import("./../../../src/pages/us.tsx" /* webpackChunkName: "component---src-pages-us-tsx" */),
  "component---src-templates-page-index-tsx": () => import("./../../../src/templates/page/index.tsx" /* webpackChunkName: "component---src-templates-page-index-tsx" */)
}

